import React, { useState } from "react";
import "./paymentMethodOtcTransaction.css";
import { formatRupiah } from "../../../../helper/formatNumber";
import { Constant } from "../../../../helper/constant";
import { useNavigate } from "react-router-dom";

const PaymentMethodOtcTransaction = ({
  listPayment,
  selectedPaymentOption,
  setSelectedPaymentOption,
  listBank,
  selectedBankOption,
  setSelectedBankOption,
  buyerCash,
  setBuyerCash,
  totalTransaction,
  partnerData,
  setPartnerData,
  listCourier,
  setCourierData,
  courierFee,
  setCourierFee,
  showCourierFeeSection,
  insuranceCovered,
  setInsuranceCovered,
  listRemainingPaymentOption,
  remainingPaymentOption,
  setSelectedRemainingPaymentOption,
}) => {
  // =====================
  // Constant Definition
  // =====================

  const navigate = useNavigate();

  const handlePaymentChange = (event) => {
    setSelectedPaymentOption(event.target.value);
    setSuggestionPartner([]);
    setPartnerData({
      partner_id: "",
      partner_name: "",
    });
  };

  const handleRemainingPayment = (event) => {
    setSelectedRemainingPaymentOption(event.target.value);
  };

  const handleBankChange = (event) => {
    const selectedBankData = listBank.find(
      (bank) => bank.bank_id === event.target.value
    );
    setSelectedBankOption(selectedBankData);
  };

  const selectPartner = (partner) => {
    setPartnerData({
      partner_id: partner.partner_id,
      partner_name: partner.partner_name,
    });
    setSuggestionPartner([]);
  };

  const [suggestionPartner, setSuggestionPartner] = useState([]);

  // =====================
  // Method Definition
  // =====================

  const checkPartnerData = (keyword) => {
    if (keyword.length > 2) {
      checkPartnerAutoComplete(keyword);
    } else {
      setSuggestionPartner([]);
    }
  };

  // =====================
  // Request Method
  // =====================

  const checkPartnerAutoComplete = async (keyword) => {
    try {
      const response = await fetch(
        Constant.BASE_API_URL + "/partner/autocomplete?keyword=" + keyword,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (!response.ok) {
        alert("Terdapat Kesalahan Dalam Memproses Data");
        if (response.status === 401 || response.status === 403) {
          localStorage.clear();
          return navigate("/login", { replace: true });
        }
      }

      const json = await response.json();
      const data = json.data;
      setSuggestionPartner(data.partners);
    } catch (error) {
      setSuggestionPartner([]);
    }
  };

  return (
    <div className="payment-container">
      <div className="payment-row">
        <div className="dropdown-payment-method-otc-transaction">
          <p className="dropdown-title">Pembayaran</p>
          <select
            value={selectedPaymentOption}
            onChange={handlePaymentChange}
            className="dropdown-select"
          >
            {listPayment.map((payment, index) => (
              <option key={index} value={payment}>
                {payment}
              </option>
            ))}
          </select>
        </div>

        {selectedPaymentOption === "REKANAN" && (
          <div className="insurance-container">
            <div className="partner-container">
              <p className="partner-title">Nama Rekanan</p>
              <div>
                <input
                  className="input-field-partner-transaction-container"
                  type="text"
                  value={
                    partnerData.partner_name ? partnerData.partner_name : ""
                  }
                  onChange={(e) => {
                    setPartnerData({
                      partner_id: "",
                      partner_name: e.target.value,
                    });
                    checkPartnerData(e.target.value);
                  }}
                  onBlur={() => setTimeout(() => setSuggestionPartner([]), 200)}
                  placeholder="Nama partner"
                />
                {suggestionPartner.length > 0 && (
                  <ul className="dropdown-list">
                    {suggestionPartner.map((partner) => (
                      <li key={partner.partner_id}>
                        <button
                          className="dropdown-button"
                          onClick={() => {
                            selectPartner(partner);
                          }}
                        >
                          {partner.partner_name}
                        </button>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
            <div className="insurance-covered-container">
              <p className="partner-title">Ditanggung Asuransi</p>
              <div>
                <input
                  className="input-field-partner-transaction-container"
                  type="text"
                  value={formatRupiah(insuranceCovered ? insuranceCovered : 0)}
                  onChange={(e) => {
                    setInsuranceCovered(Number(e.target.value));
                  }}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/\D/g, "");
                  }}
                  placeholder="Masukkan Jumlah Ditanggung Asuransi"
                />
              </div>
            </div>
            <div className="dropdown-remaining-payment-partner">
              <p className="remaining-payment-title">Sisa Bayar</p>
              <select
                value={remainingPaymentOption}
                onChange={handleRemainingPayment}
                className="dropdown-select"
              >
                {listRemainingPaymentOption.map((payment, index) => (
                  <option key={index} value={payment}>
                    {payment}
                  </option>
                ))}
              </select>
            </div>
          </div>
        )}

        {selectedPaymentOption === "TRANSFER" && (
          <div className="transfer-row">
            <div className="dropdown-payment-method-otc-transaction">
              <p className="dropdown-title">Pilih Bank</p>
              <select
                value={selectedBankOption.bank_id}
                onChange={handleBankChange}
                className="dropdown-select"
              >
                {listBank.map((bank) => (
                  <option key={bank.bank_id} value={bank.bank_id}>
                    {bank.bank_name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        )}

        {selectedPaymentOption === "CASH" && (
          <div className="buyer-exchange-container">
            <div className="buyer-container">
              <p className="dropdown-title">Uang Bayar</p>
              <input
                type="text"
                value={formatRupiah(buyerCash)}
                onChange={(e) => setBuyerCash(Number(e.target.value))}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/\D/g, "");
                }}
                className="dropdown-select"
                placeholder="Masukkan uang pembeli"
              />
            </div>
            <div className="exchange-container">
              <p className="dropdown-title">Kembalian</p>
              <input
                type="text"
                value={formatRupiah(
                  buyerCash >= totalTransaction
                    ? buyerCash - totalTransaction
                    : 0
                )}
                readOnly
                className="dropdown-select"
              />
            </div>
          </div>
        )}
      </div>

      {showCourierFeeSection && (
        <div className="payment-row">
          <div className="buyer-exchange-container">
            <div className="buyer-container">
              <p className="dropdown-title">Kurir Pengiriman</p>
              <select
                onChange={(e) => {
                  setCourierData(e.target.value);
                }}
                className="dropdown-select"
              >
                {listCourier.map((courier, index) => (
                  <option key={index} value={courier}>
                    {courier}
                  </option>
                ))}
              </select>
            </div>
            <div className="exchange-container">
              <p className="dropdown-title">Ongkos Kirim</p>
              <input
                type="text"
                value={formatRupiah(courierFee)}
                onChange={(e) => {
                  setCourierFee(Number(e.target.value));
                }}
                className="dropdown-select"
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/\D/g, "");
                }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PaymentMethodOtcTransaction;
